<template>
  <div class="page login-page">
    <video class="bg-video" autoplay loop muted playsinline>
      <source src="/img/login/4.mp4" type="video/mp4" />
    </video>

    <div class="login-content">
      <van-nav-bar class="nav-bar" :border="false" placeholder>
        <template #left>
          <van-icon name="arrow-left" color="#fff" size="24" @click="back()" />
        </template>
        <template #right>
          <div class="lang-btn" @click="$router.push('/language')">
            <van-icon name="chat-o" size="24" color="#fff" />
          </div>
        </template>
      </van-nav-bar>

      <div class="form-wrap">
        <div class="form-title">{{ $t("auth.login") }}</div>

        <div class="form-fields">
          <van-field v-model="username" clearable class="input-large" input-align="center"
            :placeholder="$t('auth.username_place')" />
            
          <van-field v-model="password" :type="passwordType" class="input-large" input-align="center"
            :placeholder="$t('auth.pwd_place')">
            <template #right-icon>
              <van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                @click="switchPasswordType" />
            </template>
          </van-field>

          <van-button class="btn-large-primary" :loading="isSubmitting" @click="doLogin()">
            {{ $t("auth.login") }}
          </van-button>
          
          <!-- 优化后的注册入口 -->
          <div @click="toRegister()" class="register-text">
            <span>{{ $t("auth.no_account") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      isSubmitting: false,
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (!this.username) return this.$toast(this.$t("auth.username_place"));
      if (!this.password) return this.$toast(this.$t("auth.pwd_place"));
      this.isSubmitting = true;
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password
        },
      }).then((res) => {
        this.isSubmitting = false;
        if (res.code === 200) {
          localStorage.setItem("token", res.data.id);
          this.$router.push("Home");
        } else {
          this.$toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .login-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    /* 防止视频溢出 */
  }

  /* 视频全屏背景样式 */
  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .login-content {
    position: relative;
    /* 确保表单层级高于视频 */
    z-index: 1;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .nav-bar {
    background: transparent !important;

    ::v-deep .van-nav-bar__content {
      height: 60px;
    }
  }

  .lang-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    cursor: pointer;
  }

  .form-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 22vh 24px 0;
  }

  .form-title {
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-bottom: 24px;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }

  .form-fields {
    width: 100%;
    max-width: 440px;
    margin: 0 auto;
  }

  .input-large {
    background: rgba(45, 45, 60, 0.75) !important;
    border-radius: 60px;
    margin-bottom: 24px;
    padding: 16px 24px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    ::v-deep .van-field__control {
      font-size: 16px;
      color: #ffffff;
    }

    ::v-deep .van-field__control::placeholder {
      color: #a0a0ab;
    }

    ::v-deep .van-field__right-icon {
      position: absolute;
      right: 24px;

      .van-icon {
        font-size: 24px;
        color: #7d7d9f;
      }
    }
  }

  .btn-large-primary {
    width: 100%;
    height: 54px;
    border-radius: 60px;
    background: #5b6cf2;
    color: #ffffff;
    border: none;
    font-size: 18px;
    font-weight: 600;
    margin: 16px 0;
    box-shadow: 0 4px 15px rgba(91, 108, 242, 0.4);
    transition: all 0.3s ease;

    &:active {
      opacity: 0.85;
      transform: scale(0.98);
    }
  }

  /* 新增/优化的注册文本样式 */
  .register-text {
    text-align: center;
    margin-top: 12px;
    padding: 10px;
    cursor: pointer;

    span {
      color: azure;
      font-size: 15px;
      letter-spacing: 0.5px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6); /* 增强背景视频下的可读性 */
      transition: all 0.3s ease;
      opacity: 0.85;
    }

    &:hover span,
    &:active span {
      opacity: 1;
      color: #ffffff;
      text-decoration: underline; /* 增加下划线提示可点击 */
    }
  }

  .form-links-center,
  .form-links-bottom {
    text-align: center;
  }

  .link-item {
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  }
</style>